__turbopack_context__.v({
  "ambientGlow": "FeatureBeacon-module__sACv8a__ambientGlow",
  "beaconContainer": "FeatureBeacon-module__sACv8a__beaconContainer",
  "beaconWrapper": "FeatureBeacon-module__sACv8a__beaconWrapper",
  "contentArea": "FeatureBeacon-module__sACv8a__contentArea",
  "featureContent": "FeatureBeacon-module__sACv8a__featureContent",
  "featureHighlight": "FeatureBeacon-module__sACv8a__featureHighlight",
  "featureIcon": "FeatureBeacon-module__sACv8a__featureIcon",
  "featureLabel": "FeatureBeacon-module__sACv8a__featureLabel",
  "iconWrapper": "FeatureBeacon-module__sACv8a__iconWrapper",
  "navDot": "FeatureBeacon-module__sACv8a__navDot",
  "navDotActive": "FeatureBeacon-module__sACv8a__navDotActive",
  "navDots": "FeatureBeacon-module__sACv8a__navDots",
  "particle": "FeatureBeacon-module__sACv8a__particle",
  "particles": "FeatureBeacon-module__sACv8a__particles",
  "progressAnimation": "FeatureBeacon-module__sACv8a__progressAnimation",
  "progressFill": "FeatureBeacon-module__sACv8a__progressFill",
  "progressPaused": "FeatureBeacon-module__sACv8a__progressPaused",
  "progressRing": "FeatureBeacon-module__sACv8a__progressRing",
  "progressTrack": "FeatureBeacon-module__sACv8a__progressTrack",
  "textContent": "FeatureBeacon-module__sACv8a__textContent",
});
